import KycIntro from './kyc-intro';

export default KycIntro;
